import React from 'react';
import IcomoonReact from "icomoon-react";
import iconSet from "../../assets/icon-fonts/selection.json";
import { withTranslation } from 'react-i18next';
import styles from './styles.module.sass';

export default withTranslation()(function BasicEmptyState({ t }) {

  return (
    <div className={styles['basic-empty-state']} >
      <IcomoonReact iconSet={iconSet} color="#310f49" size={100} icon="1553" />
      <h3>{t("No data yet")}</h3>
    </div>
  );
});